// extracted by mini-css-extract-plugin
module.exports = {"ideas-container-main":"page_ideas-container-main__XiExu","ideas-container-background":"page_ideas-container-background__xCi9X"};